// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Sentry from "../../../sentry/Sentry.bs.js";
import * as RescriptReactErrorBoundary from "../../../../../node_modules/@rescript/react/src/RescriptReactErrorBoundary.bs.js";

function CrmErrorBoundary$Reporter(Props) {
  var error = Props.error;
  var componentStack = Props.componentStack;
  var children = Props.children;
  React.useEffect((function () {
          Sentry.captureException({
                view_error: {
                  component_stack: componentStack
                }
              }, {
                error_kind: "VIEW_ERROR",
                type: "VIEW_ERROR",
                caught_by: "CrmErrorBoundary"
              }, error);
          
        }), []);
  return React.createElement(React.Fragment, undefined, children);
}

var Reporter = {
  make: CrmErrorBoundary$Reporter
};

function CrmErrorBoundary(Props) {
  var children = Props.children;
  var fallBackComponent = Props.fallBackComponent;
  return React.createElement(RescriptReactErrorBoundary.make, {
              children: children,
              fallback: (function (params) {
                  return React.createElement(CrmErrorBoundary$Reporter, {
                              error: params.error,
                              componentStack: params.info.componentStack,
                              children: React.createElement(fallBackComponent, {
                                    error: params.error
                                  })
                            });
                })
            });
}

var make = CrmErrorBoundary;

export {
  Reporter ,
  make ,
  
}
/* react Not a pure module */
